// src/routes/PublicOnlyRoute.tsx
import { Navigate, Outlet } from 'react-router-dom';
import { isAuthenticated } from '../services/auth';

export default function PublicOnlyRoute() {
  const auth = isAuthenticated();
  if (auth) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}

